module.exports = __webpack_public_path__ + "static/1-b82e29bbd6fc3e6494797792c8b3e5b0.png";